export default __webpack_public_path__ + "static/media/aws2021practice00-aws-selfstudy-advice-v02.b8e77ab0.pdf";